import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class ModalService {
  private modals: { [key: string]: { open: boolean; data?: any; canClose?: boolean; isEdition?: boolean } } = {};

  openModal(type: string, data?: any, isEdition: boolean = false) {
    this.modals[type] = { open: true, data, canClose: true, isEdition };
  }

  closeModal(type: string) {
    if (this.modals[type] && this.modals[type].canClose !== false) {
      this.modals[type].open = false;
      this.modals[type].data = undefined;
    }
  }

  setCanClose(type: string, canClose: boolean) {
    if (this.modals[type]) {
      this.modals[type].canClose = canClose;
    }
  }

  getIsEdition(type: string): boolean {
    return !!this.modals[type]?.isEdition;
  }

  isModalOpen(type: string): boolean {
    return !!this.modals[type]?.open;
  }

  getData<T = any>(type: string): T | undefined {
    return this.modals[type]?.data as T;
  }
}
